import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DesignSprintComponent } from './design-sprint/design-sprint.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardCreditCardsComponent } from './dashboard-credit-cards/dashboard-credit-cards.component';
import { DashboardLoansComponent } from './dashboard-loans/dashboard-loans.component';
import { BranchLocatorComponent } from './branch-locator/branch-locator.component'
import { PayCardComponent } from './pay-card/pay-card.component';
import { StopCardComponent } from './stop-card/stop-card.component';
import { ChangeCardPinComponent } from './change-card-pin/change-card-pin.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LoanNicknameComponent } from './loan-nickname/loan-nickname.component';
import { CardNickNameComponent } from './card-nick-name/card-nick-name.component';
import { ChangePinComponent } from './change-pin/change-pin.component';
import { PayCardSuccessComponent } from './pay-card-success/pay-card-success.component';
import { PayCardErrorComponent } from './pay-card-error/pay-card-error.component';
import { QuickPaymentComponent } from './quick-payment/quick-payment.component';
import { CardTransactionHistoryComponent } from './card-transaction-history/card-transaction-history.component';
import { LoanPaymentHistoryComponent } from './loan-payment-history/loan-payment-history.component';
import { MonthSelectComponent } from './month-select/month-select.component';
import { ChangePinVerifyComponent } from './imtiaz-verification/change-pin-verify/change-pin-verify.component';
import { LoyaltyPointsComponent } from './loyalty-points/loyalty-points.component';
import { LoyaltyPointsRadeemComponent } from './loyalty-points-radeem/loyalty-points-radeem.component';
import { LoyaltyPointsRadeemConfirmComponent } from './loyalty-points-radeem-confirm/loyalty-points-radeem-confirm.component';
import { LoyaltyPointsRadeemSuccesComponent } from './loyalty-points-radeem-succes/loyalty-points-radeem-succes.component';
import { CardReplacementSuccessComponent } from './card-replacement-success/card-replacement-success.component';
import { SettingsComponent } from './settings/settings.component';
import {CardPageComponent} from './card-page/card-page.component';
import { SettingsUpdateEmailComponent } from './settings-update-email/settings-update-email.component';
import { SettingsUpdateMobileNumberComponent } from './settings-update-mobile-number/settings-update-mobile-number.component';
import { InboxComponent } from './inbox/inbox.component';
import { CardLimitPermanentComponent } from './card-limit-permanent/card-limit-permanent.component';
import { CardLimitTemporaryComponent } from './card-limit-temporary/card-limit-temporary.component';
import { CardUploadDocumentComponent } from './card-upload-document/card-upload-document.component';
import { CardLimitSuccessComponent } from './card-limit-success/card-limit-success.component';

import { AuthGuardService as Auth } from './Services/auth-guard.service';
import { CardLimitDeclineComponent } from './card-limit-decline/card-limit-decline.component';
import { ReachUsComponent } from "./reach-us/reach-us.component";
import { ReachUsPageComponent } from "./reach-us-page/reach-us-page.component";
import { FeedbacksComponent } from "./feedbacks/feedbacks.component";
import { FeedbackSuccessComponent } from "./feedback-success/feedback-success.component";
import { TypeOfProductComponent } from "./type-of-product/type-of-product.component";
import { SelectPaymentMethodComponent } from "./select-payment-method/select-payment-method.component";
import { TypeOfPayComponent } from "./type-of-pay/type-of-pay.component";
import { PayCardSuspendedComponent } from "../app/pay-card-suspended/pay-card-suspended.component";
import { PayCardReviewComponent } from "./pay-card-review/pay-card-review.component";
import { CardRequestSupplementaryComponent } from "./card-request-supplementary/card-request-supplementary.component";
import { CardRequestVerifyYourselfComponent } from "./card-request-verify-yourself/card-request-verify-yourself.component";
import { CardRequestUploadIdComponent } from "./card-request-upload-id/card-request-upload-id.component";
import { CardRequestConfrimDetailsComponent } from "./card-request-confrim-details/card-request-confrim-details.component";
import { CardRequestLimitSettingComponent } from "./card-request-limit-setting/card-request-limit-setting.component";
import { CardRequestPhysicalCardComponent } from "./card-request-physical-card/card-request-physical-card.component";
import { CardRequestNameAppearComponent } from "./card-request-name-appear/card-request-name-appear.component";
import { CardRequestLettersComponent } from "./card-request-letters/card-request-letters.component";
import { PayLoanSuccessComponent } from "./pay-loan-success/pay-loan-success.component";
import { LoanDeferInstalmentComponent } from "./loan-defer-instalment/loan-defer-instalment.component";
import { LoanDeferUploadDocComponent } from "./loan-defer-upload-doc/loan-defer-upload-doc.component";
import { LoanReviewSuccessComponent } from "./loan-review-success/loan-review-success.component";
import { SettingManageAddressComponent } from "./setting-manage-address/setting-manage-address.component";
import { SettingEditPrimaryEmailComponent } from "./setting-edit-primary-email/setting-edit-primary-email.component";
import { SettingPushNotificationsComponent } from "./setting-push-notifications/setting-push-notifications.component";
import { RewardsLoyaltyPointsComponent } from "./rewards-loyalty-points/rewards-loyalty-points.component";
import { LandingPageOffersComponent } from "./landing-page-offers/landing-page-offers.component";
import { LandingPageMyFavouritesComponent } from "./landing-page-my-favourites/landing-page-my-favourites.component";
import { LandingPageOfferDetailsComponent } from "./landing-page-offer-details/landing-page-offer-details.component";
import { InsuranceComponent } from './insurance/insurance.component';
import { InsuranceAssistanceComponent } from './insurance-assistance/insurance-assistance.component';
import { InsuranceClaimsComponent } from './insurance-claims/insurance-claims.component';
import { InsuranceBenefitsDocumentsComponent } from './insurance-benefits-documents/insurance-benefits-documents.component';
import { InsurancrNickComponent } from './insurancr-nick/insurancr-nick.component';
import { EnterMobilePinComponent } from './enter-mobile-pin/enter-mobile-pin.component';
import { BranchTicketIssuedComponent } from './branch-ticket-issued/branch-ticket-issued.component';
import { PayCardFailedComponent } from './pay-card-failed/pay-card-failed.component';
import { ChangeCardPinConfirmComponent } from './change-card-pin-confirm/change-card-pin-confirm.component';
import { ChangeCardPinSinnadComponent } from './change-card-pin-sinnad/change-card-pin-sinnad.component';
import { EmailOtpVerifyComponent } from './email-otp-verify/email-otp-verify.component';
import { MobileOtpVerifyComponent } from './mobile-otp-verify/mobile-otp-verify.component';
import { ChangeCardPinSinnadSuccessComponent } from './change-card-pin-sinnad-success/change-card-pin-sinnad-success.component';
import { SuccessPaymentComponent } from './success-payment/success-payment.component';
import { PasswordComponent } from './password/password.component';
import { CreatePasswordComponent } from "./create-password/create-password.component";
import { VerifyEmailMobileComponent } from "./verify-email-mobile/verify-email-mobile.component";
import { SelectServiceComponent } from "./select-service/select-service.component";
import { PaymentSuccessfulComponent } from "./payment-successful/payment-successful.component";
import { EKeyFailedComponent } from "./e-key-failed/e-key-failed.component";
import { SuccessComponent } from "./success/success.component";
import { FailureComponent } from "./failure/failure.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "LoginWithIdNum",
    pathMatch: "full",
  },
  // { path: 'Login', component: LoginComponent
  // },
  { path: "DesignSprint", component: DesignSprintComponent },
  { path: "Dashboard", component: DashboardComponent, canActivate: [Auth] },
  {
    path: "DashboardCreditCards",
    component: DashboardCreditCardsComponent,
    canActivate: [Auth],
  },
  {
    path: "DashboardLoans",
    component: DashboardLoansComponent,
    canActivate: [Auth],
  },
  // { path: "PayCard", component: PayCardComponent, canActivate: [Auth] },
  { path: "PayCard", component: PayCardComponent },
  { path: "StopCard", component: StopCardComponent, canActivate: [Auth] },
  {
    path: "ChangeCardPin",
    component: ChangeCardPinComponent,
    canActivate: [Auth],
  },
  {
    path: "LandingPage",
    component: LandingPageComponent,
  },
  {
    path: "LoanNickname",
    component: LoanNicknameComponent,
    canActivate: [Auth],
  },
  {
    path: "CardNickName",
    component: CardNickNameComponent,
    canActivate: [Auth],
  },
  {
    path: "ChangePin",
    component: ChangePinComponent,
    canActivate: [Auth],
  },
  {
    path: "PayCardSuccess",
    component: PayCardSuccessComponent,
  },
  {
    path: "QuickPayment",
    component: QuickPaymentComponent,
  },
  {
    path: "PayCardError",
    component: PayCardErrorComponent,
  },
  {
    path: "CardTransactionHistory",
    component: CardTransactionHistoryComponent,
    canActivate: [Auth],
  },
  {
    path: "LoanPaymentHistory",
    component: LoanPaymentHistoryComponent,
    canActivate: [Auth],
  },
  {
    path: "MonthSelect",
    component: MonthSelectComponent,
    canActivate: [Auth],
  },
  {
    path: "existingCustomer",
    loadChildren: () =>
      import("./existing-customer/existing-customer.module").then(
        (mod) => mod.ExistingCustomerModule
      ),
  },
  {
    path: "BranchLocator",
    component: BranchLocatorComponent,
  },
  {
    path: "ChangePinVerify",
    component: ChangePinVerifyComponent,
  },
  {
    path: "LoyaltyPoints",
    component: LoyaltyPointsComponent,
  },
  {
    path: "LoyaltyPointsRadeem",
    component: LoyaltyPointsRadeemComponent,
  },
  {
    path: "LoyaltyPointsRadeemConfirm",
    component: LoyaltyPointsRadeemConfirmComponent,
  },
  {
    path: "LoyaltyPointsRadeemSucces",
    component: LoyaltyPointsRadeemSuccesComponent,
  },
  {
    path: "CardReplacementSuccess",
    component: CardReplacementSuccessComponent,
  },
  {
    path: "SettingsUpdateEmail",
    component: SettingsUpdateEmailComponent,
  },
  {
    path: "SettingsUpdateMobileNumber",
    component: SettingsUpdateMobileNumberComponent,
  },
  {
    path: "Inbox",
    component: InboxComponent,
  },
  {
    path: "Settings",
    component: SettingsComponent,
  },
  {
    path: "CardPage",
    component: CardPageComponent,
  },
  {
    path: "CardLimitPermanent",
    component: CardLimitPermanentComponent,
  },
  {
    path: "CardLimitTemporary",
    component: CardLimitTemporaryComponent,
  },
  {
    path: "CardLimitDecline",
    component: CardLimitDeclineComponent,
  },
  {
    path: "CardUploadDocument",
    component: CardUploadDocumentComponent,
  },
  {
    path: "CardLimitSuccess",
    component: CardLimitSuccessComponent,
  },
  {
    path: "ReachUs",
    component: ReachUsComponent,
  },
  {
    path: "ReachUsPage",
    component: ReachUsPageComponent,
  },
  {
    path: "Feedbacks",
    component: FeedbacksComponent,
  },
  {
    path: "FeedbackSuccess",
    component: FeedbackSuccessComponent,
  },
  {
    path: "Success",
    component: SuccessComponent,
  },
  {
    path: "TypeOfProduct",
    component: TypeOfProductComponent,
  },
  {
    path: "SelectPaymentMethod",
    component: SelectPaymentMethodComponent,
  },
  {
    path: "TypeOfPay",
    component: TypeOfPayComponent,
  },
  {
    path: "PayCardSuspended",
    component: PayCardSuspendedComponent,
  },
  {
    path: "TypeOfPay",
    component: TypeOfPayComponent,
  },
  {
    path: "PayCardReview",
    component: PayCardReviewComponent,
  },
  {
    path: "CardRequestSupplementary",
    component: CardRequestSupplementaryComponent,
  },
  {
    path: "CardRequestVerifyYourself",
    component: CardRequestVerifyYourselfComponent,
  },
  {
    path: "CardRequestUploadId",
    component: CardRequestUploadIdComponent,
  },
  {
    path: "CardRequestConfrimDetails",
    component: CardRequestConfrimDetailsComponent,
  },
  {
    path: "CardRequestLimitSetting",
    component: CardRequestLimitSettingComponent,
  },
  {
    path: "CardRequestPhysicalCard",
    component: CardRequestPhysicalCardComponent,
  },
  {
    path: "CardRequestNameAppear",
    component: CardRequestNameAppearComponent,
  },
  {
    path: "CardRequestLetters",
    component: CardRequestLettersComponent,
  },
  {
    path: "PayLoanSuccess",
    component: PayLoanSuccessComponent,
  },
  {
    path: "LoanDeferInstalment",
    component: LoanDeferInstalmentComponent,
  },
  {
    path: "LoanDeferUploadDoc",
    component: LoanDeferUploadDocComponent,
  },
  {
    path: "LoanReviewSuccess",
    component: LoanReviewSuccessComponent,
  },
  {
    path: "SettingManageAddress",
    component: SettingManageAddressComponent,
  },
  {
    path: "SettingEditPrimary",
    component: SettingEditPrimaryEmailComponent,
  },
  {
    path: "SettingPushNotifications",
    component: SettingPushNotificationsComponent,
  },
  {
    path: "RewardsLoyaltyPoints",
    component: RewardsLoyaltyPointsComponent,
  },
  {
    path: "LandingPageOffers",
    component: LandingPageOffersComponent,
  },
  {
    path: "LandingPageMyFavourites",
    component: LandingPageMyFavouritesComponent,
  },
  {
    path: "LandingPageOfferDetails",
    component: LandingPageOfferDetailsComponent,
  },
  {
    path: "Insurance",
    component: InsuranceComponent,
  },
  {
    path: "InsuranceAssistance",
    component: InsuranceAssistanceComponent,
  },
  {
    path: "InsuranceClaims",
    component: InsuranceClaimsComponent,
  },
  {
    path: "InsuranceBenefitsDocuments",
    component: InsuranceBenefitsDocumentsComponent,
  },
  {
    path: "InsuranceNick",
    component: InsurancrNickComponent,
  },
  {
    path: "EnterMobilePin",
    component: EnterMobilePinComponent,
  },
  {
    path: "BranchTicketIssued",
    component: BranchTicketIssuedComponent,
  },
  {
    path: "PayCardFailed",
    component: PayCardFailedComponent,
  },
  {
    path: "ChangeCardPinConfirm",
    component: ChangeCardPinConfirmComponent,
  },
  {
    path: "ChangeCardPinSinnad",
    component: ChangeCardPinSinnadComponent,
  },
  {
    path: "EmailOtpVerify",
    component: EmailOtpVerifyComponent,
  },
  {
    path: "MobileOtpVerify",
    component: MobileOtpVerifyComponent,
  },
  {
    path: "ChangeCardPinSinnadSuccess",
    component: ChangeCardPinSinnadSuccessComponent,
  },
  {
    path: "SuccessPayment",
    component: SuccessPaymentComponent,
  },
  {
    path: "password",
    component: PasswordComponent,
  },

  {
    path: "CreatePassword",
    component: CreatePasswordComponent,
  },
  {
    path: "VerifyEmailMobile",
    component: VerifyEmailMobileComponent,
  },
  {
    path: "SelectService",
    component: SelectServiceComponent,
  },
    {
    path: "EkeySuccess",
    component: PaymentSuccessfulComponent,
  },
   {
    path: "EkeyFailed",
    component: EKeyFailedComponent,
  },
  {
    path: "Failure",
    component: FailureComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]

})
export class AppRoutingModule { }
